import styled from 'styled-components';
import { device } from '../media_queries';

const GMMain = styled.div`
  width: 90%;
  /* ${props => props.width}; */
  /*  */
  height: 70%; 
  /* ${props => props.height}; */
  /* */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;
export { GMMain };